export default __webpack_public_path__ + "static/3-8f3fd506b795e602347b9ad460b7f724.jpeg";